'use client';

import Image from 'next/image';
import Link from 'next/link';

import { useGTMPromotionBanner } from '@/fo/api/gtm';
import ArrowIcon from '@/fo/icons/base/icons/big-arrow.svg';
import { UiAdvertisingInformerBase } from '@/fo/ui/advertising/informer/base';

import { styles } from './UiKitBannerGiftCard.styles';

type NativeElement = React.HTMLAttributes<HTMLDivElement>;

export interface UiKitBannerGiftCardProps {
  className?: string;
  title: React.ReactNode;
  text: React.ReactNode;
  desktopImage: string;
  mobileImage: string;
  alt?: string;
  link?: string;
  buttonText?: string;
  promotionName?: string;
  onClick?: NativeElement['onClick'];
  erid?: string;
  advertisingWarningText?: string;
}

export function UiKitBannerGiftCard({
  className,
  title,
  text,
  desktopImage,
  mobileImage,
  alt = '',
  link,
  buttonText,
  promotionName = '',
  erid,
  advertisingWarningText,
  ...props
}: UiKitBannerGiftCardProps) {
  const slots = styles();
  const { ref, trackSelectPromotion } = useGTMPromotionBanner({
    creativeName: desktopImage || mobileImage,
    promotionId: link,
    promotionName,
    source: 'static',
    index: 1
  });

  return (
    <div
      ref={ref}
      className={slots.base({ className })}
      {...props}
    >
      {erid && (
        <UiAdvertisingInformerBase
          erid={erid}
          advertisingWarningText={advertisingWarningText}
          className={slots.advertisingInformer()}
          classNameContent={slots.advertisingInformerContent()}
        />
      )}
      <picture>
        <source
          srcSet={mobileImage}
          media="(max-width: 639px)"
        />
        <Image
          alt={alt}
          src={desktopImage}
          width={1360}
          height={200}
          className={slots.image()}
        />
      </picture>
      <div className={slots.content()}>
        <div className={slots.body()}>
          <div className={slots.title()}>{title}</div>
          <p
            className={slots.text()}
            dangerouslySetInnerHTML={{ __html: text as string }}
          ></p>
          {buttonText && (
            <Link
              href={link || '/'}
              onClick={trackSelectPromotion}
            >
              <span className={slots.link()}>
                <span className={slots.linkText()}>{buttonText}</span>
                <span className={slots.linkIcon()}>
                  <ArrowIcon />
                </span>
              </span>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
